import Vue from 'vue'
import employAxios from '../libraries/utils/employAxios'
import Admin from '../components/admin'
import Login from '../components/admin/login'//登录
import SsgMain from '../components/main/index'
import entry from '../components/entry/entry.vue'
import SsgPersonSet from '../components/settings/person.vue'
import MessageList from '../components/settings/messageList.vue'

import SsgChangePasswd from '../components/settings/changepasswd.vue'
import System from '../components/system/index.vue'
import Company from '../components/system/company.vue'

import Contract from '../components/system/contractCompany'
import Seal from '../components/system/contractCompany/seal'
import Create from '../components/system/contractCompany/seal/create.vue'
import Account from '../components/system/account'
import AddAccount from '../components/system/account/addAccount'
import Jurisdiction from "../components/system/account/jurisdiction.vue"
import RightsGroups from '../components/system/rightsGroups'
import AddRightsGroups from '../components/system/rightsGroups/addRightsGroups.vue'
import CompileRightsGroups from '../components/system/rightsGroups/compileRightsGroups.vue'
import OrgManage from '../components/system/orgManage'
import SsgSplat from '../components/ssgSplat/index'//嗖嗖管系统
import AddItem from '../components/ssgSplat/addItem.vue'//添加项目
import Settings from '../components/ssgSplat/settings/index'//关联设置
import DataCenter from '../components/ssgSplat/dataCenter.vue' //数据中心
import RelatedSetting from '../components/ssgSplat/settings/relatedSetting.vue'//关联设置详情
import RelateRpoSetting from '../components/ssgSplat/settings/relateRpoSetting.vue'//关联设置rpo
import RelateRpoDetails from '../components/ssgSplat/settings/relateRpoDetails.vue'//关联设置rpo详情
import EmployPlatform from '../components/ssgSplat/settings/employPlatform.vue'//企业多元用工平台
import EmployEdit from '../components/ssgSplat/settings/employEdit.vue'//企业多元用工平台-编辑


import Accpermission from '../components/ssgSplat/accpermission.vue'//账号权限列表
import Addcoll from '../components/ssgSplat/addcoll.vue'//添加协作者

import SsgBacktone from '../components/ssgBacktone'//背调列表
import AddBackMan from '../components/ssgBacktone/addBackMan.vue'//背调列表
import Result from '../components/ssgBacktone/result.vue'//背调列表

import SsgNewAttend from '../components/ssgNewAttend/index'  //
import Page from '../components/ssgNewAttend/page.vue'  //
import AttendAddItem from '../components/ssgNewAttend/addItem.vue'
import RelateSetting from '../components/ssgNewAttend/relateSet/index.vue'
import RelateCompany from '../components/ssgNewAttend/relateSet/relateCompany.vue'
import AttendPower from '../components/ssgNewAttend/relateSet/attendPower.vue'
import Attendpermission from '../components/ssgNewAttend/attendpermission.vue'
import AttendAddcoll from '../components/ssgNewAttend/attendAddcoll.vue'


// import { create } from 'core-js/fn/object'


let ssgRouters = function (Setting) {
  let node = 'sshr-service-platForm'
  let routes = [
    {
      path: '/',
      redirect: '/login',
    },


    {
      path: '/Admin',
      component: Admin,
      meta: {
        title: "登录",
      },

      children: [

        {
          path: '/',

        },
        
        {
          name: 'Index',
          path: '/index',
          component: Setting.CompanyId,
          meta: {
            title: "企业实名验证",
            node: node
          },
        },
        {
          name: 'LicenceCllect',
          path: '/licenceCllect',
          component: Setting.LicenceCllect,
          meta: {
            title: "营业执照信息收集",
            node: node
          },
        },
        {
          name: 'RealName',
          path: '/realName',
          component: Setting.RealName,
          meta: {
            title: "线下实名认证",
            node: node
          },
        },
        {
          name: 'AccountCllect',
          path: '/accountCllect',
          component: Setting.AccountCllect,
          meta: {
            title: "对公账号信息收集",
            node: node
          }
        },
        {
          path: '/login',
          name: 'login',
          component: Login,
          meta: {
            title: "登录"
          }
        },
        {
          path: '/nopermission',
          component: Setting.SsgNoPermission,
          meta: {
            title: '无权访问',
            node: node
          }
        },
        {
          path: '/stopusing',
          component: Setting.StopUsing,
          meta: {
            title: '企业停用'
          }
        },
        {
          path: '/main',
          name: 'main',
          component: SsgMain,
          meta: {
            title: "主页"
          },
          children: [
            {
              path: 'ssgBacktone',
              component: SsgBacktone,
              meta: {
                title: "背调列表",
              }
            },
            
            {
              path: 'ssgBacktone/addBackMan',
              component: AddBackMan,
              meta: {
                title: "添加背调人",
              }
            },
            
            {
              path: 'ssgBacktone/result',
              component: Result,
              name:'result',
              meta: {
                title: "查看背调结果",
              }
            },
            {
              path: '/',
              name: 'entry',
              component: entry,

              meta: {
                title: "主页",



              }

            },

        
            {
              path: 'settings/messageList',
              name: 'messageList',
              component: MessageList,
              meta: {
                title: '消息中心列表',
              }
            },
            {
              path: 'settings/person',
              name: 'SsgPersonSet',
              component: SsgPersonSet,
              meta: {
                title: '个人设置',
              }
            }, {
              path: '/setting/person/changePasswd',
              component: SsgChangePasswd,
              name: 'changePasswd',
              meta: {
                title: '更改密码',
              }
            },
           
            {
              path: 'system',
              component: System,
              meta: {
                title: '企业设置',
              },
              children: [
                {
                  path: '/',
                  redirect: 'system/company'
                },
                {
                  path: 'system/company',
                  name: 'company',
                  component: Company,
                  meta: {
                    title: '企业设置',
                  }
                },
                {
                  path: 'system/contractCompany',
                  component: Contract,
                  name: 'contract',

                  meta: {
                    title: '合同公司',
                  },

                },
                {
                  path: 'system/contractCompany/seal',
                  component: Seal,
                  name: 'seal',

                  meta: {
                    title: '合同印章',
                  },
                },
                {
                  path: 'system/contractCompany/seal/create',
                  component: Create,
                  name: 'seal-created',

                  meta: {
                    title: '合同印章',
                  },
                },
                {
                  path: 'system/account',
                  component: Account,
                  name: 'account',

                  meta: {
                    title: '账号管理',
                  },
                },
                {
                  path: 'system/account/addAccount',
                  component: AddAccount,
                  name: 'addAccount',

                  meta: {
                    title: '创建账号',
                  },
                },
                {
                  path: 'system/account/jurisdiction',
                  component: Jurisdiction,
                  name: 'jurisdiction',

                  meta: {
                    title: '编辑权限'
                  }
                },
                {
                  path: 'system/rightsGroups',
                  component: RightsGroups,
                  name: 'rightsGroups',

                  meta: {
                    title: '创建账号',
                  },

                },
                {
                  path: 'system/rightsGroups/compileRightsGroups',
                  component: CompileRightsGroups,
                  name: 'compileRightsGroups',

                  meta: {
                    title: '编辑权限组',
                  },

                },
                {
                  path: 'system/rightsGroups/addRightsGroups',
                  component: AddRightsGroups,
                  name: 'addRightsGroups',

                  meta: {
                    title: '创建权限组',
                  },

                },
                {
                  path: 'system/orgManage',
                  component: OrgManage,
                  name: 'orgManage',

                  meta: {
                    title: '组织管理',
                  },

                },


              ]

            },



          ]

        },


      ]
    },
   
    {
      path: '/ssgSplat',
      component: SsgSplat,
      meta: {
        title: "项目列表",
      }
    },
    {
      path: '/ssgSplat/addItem',
      component: AddItem,
      meta: {
        title: "添加项目",
      },

    },
    
    {
      path: '/ssgSplat/dataCenter',
      component: DataCenter,
      meta: {
        title: "数据中心",
      },

    },
    {
      path: '/ssgSplat/settings',
      component: Settings,
      name: 'settings',

      meta: {
        title: "关联设置",
      },
      children: [
        {
          path: '/ssgSplat/settings/relatedSetting',
          component: RelatedSetting,
          name: 'relatedSetting',

          meta: {
            title: "关联设置详情",
          },
        },
        {
          path: '/ssgSplat/settings/relateRpoSetting',
          component: RelateRpoSetting,
          name: 'relateRpoSetting',

          meta: {
            title: "关联设置RPO列表",
          },
        },
        
        {
          path: '/ssgSplat/settings/employPlatform',
          component: EmployPlatform,
          name: 'employPlatform',
          meta: {
            title: "企业多元用工平台列表",
          },
        },
        {
          path: '/ssgSplat/settings/attendPower',
          component: EmployEdit,
          name: 'attendPower',
          meta: {
            title: "关联项目数据设置",
          },
        },
        {
          path: '/ssgSplat/settings/relateRpoDetails',
          component: RelateRpoDetails,
          meta: {
            title: '关联设置RPO详情'
          }
        },
        {
          path: '/ssgSplat/settings/relateRpoDetails',
          component: RelateRpoDetails,
          meta: {
            title: '账号权限列表'
          }
        }
      ]

    },
    {
      path: '/ssgSplat/accpermission',
      component: Accpermission,
      meta: {
        title: "账号权限列表",
      },

    },
    {
      path: '/ssgSplat/addcoll',
      component: Addcoll,
      meta: {
        title: "添加协作者",
      },

    },
    {
      path: '/ssgNewAttend',
      component: SsgNewAttend,
      meta: {
        title: "项目列表",
      },
    },
    {
      path: '/ssgNewAttend/page',
      component: Page,
      meta: {
        title: "项目列表",
      },
    },
    {
      path: '/ssgNewAttend/addItem',
      component: AttendAddItem,
      meta: {
        title: "添加协作者",
      },
    },
    {
      path: '/ssgNewAttend/relateSet',
      component: RelateSetting,
      meta: {
        title: "关联设置",
      },
      children:[
        {
          path: '/ssgNewAttend/relateSet/relateCompany',
          component: RelateCompany,
          name:"relateCompany",
          meta: {
            title: "关联设置",
          },
        },
        {
          path: '/ssgNewAttend/relateSet/attendPower',
          component: AttendPower,
          meta: {
            title: "关联项目数据设置",
          },
        },
      ]
    },
    {
      path: '/ssgNewAttend/attendpermission',
      component: Attendpermission,
      meta: {
        title: "账号权限列表",
      },
    },
    {
      path: '/ssgNewAttend/attendAddcoll',
      component: AttendAddcoll,
      meta: {
        title: "添加协作者",
      },
    }
  ];
  return routes;

}

let routerInterceptor = function (to, from, next) {
  let btnPermissionsStr = sessionStorage.getItem("btnPermissions");
  if (!btnPermissionsStr) {
    let codes = ''
    employAxios.get("/permission/getCodes").then(res => {
      for (var i = 0; i < res.data.data.length; i++) {
        let vvv = ''
        codes += res.data.data[i] + ','
        var str = codes.substring(0, codes.length - 1)
      }
      codes = str
      sessionStorage.clear();
      sessionStorage.setItem("btnPermissions", codes);
      interceptors(to, from, next)
    });
  } else {
    interceptors(to, from, next)
  }
}

const interceptors = function (to, from, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.meta.viewpermissions) {
    let permissions = new Set(to.meta.viewpermissions.split(','));
    if (!Vue.prototype.$_has(permissions)) {
      if (to.name == "project") {
        next({ path: '/projectMangement/shortLetter', query: { 'origin': 'shortLetter' } });
      } else if (to.name == "shortLetter") {
        next({ path: '/projectMangement/email', query: { 'origin': 'email' } });
      } else if (to.name == "email") {
        next({ path: '/nopermission' });
      } else {
        // next({path: '/nopermission'});
        next({ path: to.matched[2].path + '/' + 'nopermission' });   //修改权限
      }
    } else {
      next();
    }
  } else if (to.meta.viewpage) {
    for (let a in to.meta.viewpage) {
      let btnPermissions = new Set([a]);
      if (Vue.prototype.$_has(btnPermissions)) {
        next({ path: to.fullPath + '/' + to.meta.viewpage[a] })
        break;
      }
    }
    //2021.7.16 此处可能造成其他bug
    next();
  } else {
    next();
  }
  // if (to.meta.node != 'sshr-service-platForm') {
  //   let os = Vue.prototype.$cookieStore.getCookie('_os')
  //   if (os == '"FAojbuykRT0bw2m5wHN9/A=="') {
  //     next();
  //   } else {
  //     next({path: '/stopusing'});
  //   }
  // }
}

export { ssgRouters, routerInterceptor }
